import Cookies from 'js-cookie';

const cookieName = "authIdToken";

export class FirebaseAuthCookie {

    static clear() {
        Cookies.remove(cookieName, {path: '/'});
    }

    static setToken(token) {
        Cookies.set(cookieName,
            token,
            {
                expires: 1,
                path: '/',
                secure: true
            }
        );
    }
}
